import React, { useCallback, useState } from 'react'
import { useStyles } from '../style'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { ReactComponent as IllustrationSvg } from './illustration.svg'
import Auth from '@aws-amplify/auth'

const Expired = ({ username, verifyUrl }) => {
  const classes = useStyles()

  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState({ status: false, message: '' })

  const resendLink = useCallback(async () => {
    setLoading(true)
    try {
      const success = await Auth.resendSignUp(username, { verifyUrl })
      console.log(success)
      setResponse({
        status: true,
        message: 'A new confirmation link has been sent to your email.'
      })
    } catch (err) {
      console.log(err)
      setResponse({
        status: false,
        message: err.message.toLowerCase()
      })
    } finally {
      setLoading(false)
    }
  }, [username, verifyUrl])

  return (
    <>
      <Typography className={classes.heading}>
        Sorry, the link has expired
      </Typography>
      <Box className={classes.containerContent}>
        <Typography className={classes.subtitle2}>
          Please, click below to request a new activation link.
        </Typography>
        <Typography className={classes.subtitle2}>
          The activation link will expire in 24 hours.
        </Typography>
        <Box marginY={4}>
          {response.message
            ? (
              <Typography className={classes.description}>
                {response.message}
              </Typography>
              )
            : (
              <Button
                variant='contained'
                endIcon={loading && <CircularProgress size={20} />}
                classes={{
                  root: classes.btn,
                  endIcon: classes.loadingIcon
                }}
                onClick={resendLink}
                disabled={loading}
                fullWidth
              >
                Resend activation link
              </Button>
              )}
        </Box>

        <Box className={classes.illustration}>
          <IllustrationSvg />
        </Box>
      </Box>
    </>
  )
}

export default Expired
